import React, { Component, Suspense, lazy } from 'react';
import { connect } from 'react-redux';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Draggable from 'react-draggable';
import LogRocket from 'logrocket';

// import { FaTimes } from 'react-icons/fa';
import styled from 'styled-components';
import 'react-datepicker/dist/react-datepicker.css';
import history from './utils/history';
import FileViewerModal from './components/common/FileViewer';
import IFrame from './components/common/Iframe';

import OnboardingStart from './containers/onboarding/OnboardingStart';
import Carousel from './containers/onboarding/OnboardingCarousel';
import OnboardingCorporate from './containers/onboarding/OnboardingCorporate';
import OnboardingVerifyOtp from './containers/onboarding/OnboardingVerifyOtp';
import OneLastStep from './containers/onboarding/OneLastStep';
import SubscriptionActivated from './containers/onboarding/SubscriptionActivated';
import CorporateBenefitsActivated from './containers/onboarding/CorporateBenefitsActivated';
import HomeTabContainer from './containers/home/HomeTabContainer';
import SelectUserType from './containers/onboarding/SelectUserType';
import MealLogNavigator from './containers/meal-log/MealLogNavigator';
import WhatsNotCovered from './containers/policy/WhatsNotCovered';
import RewardsNavigator from './containers/rewards/RewardsNavigator';
import HraNavigator from './containers/hra/HraNavigator';
import PhonepePaymentProcessing from './containers/common/PhonepePaymentProcessing';
import SsoContainer from './containers/home/SsoContainer';
import AuthTokenContainer from './containers/home/AuthTokenContainer';
// import OnboardingHome from './containers/onboarding/OnboardingHome';
import { RegularText, BoldText } from './components/common/Text';
import StyledTappable from './components/common/StyledTappable';
import ErrorModal from './containers/common/ErrorModal';
// import modalIcon from './images/common/paymentFail.svg';
import errorModalBg from './images/common/error-modal-bg.svg';
import errorModalIcon from './images/common/error-modal.svg';
import closeIcon from './images/lab-test/closeBlack.svg';
import { hideError, setAppConfig } from './actions/index';
import ReferContainer from './containers/home/ReferContainer';
import { appConfig, callMetaApi } from './services';
import BotChatContainer from './containers/bot/BotChatContainer';
// import ReimbursementNavigator from './containers/reimbursement/ReimbursementNavigator';
import AccountActivationForm from './containers/common/AccountActivationForm';
import ClaimsNavigator from './containers/claims/ClaimsNavigator';
// import PharmacyNavigator from './containers/pharmacy/PharmacyNavigator';
import SupportWindow from './containers/Support';
import BuyingJourneyNavigator from './containers/buying-journey/BuyingJourneyNavigator';
import VideoCallContainer from './containers/consultation/VideoCallContainer';
// analytics
import { initializeAmplitudeClient } from './utils/logEvent';
import VideoCallScreen from './containers/consultation/VideoCallScreen';
import LoadingComponent from './components/common/LoadingComponent';
import ManageDependents from './containers/home/ManageDependents';
//CSS
import './App.css';
import './comman-txt.css';
import './spacing.css';
import './Calendar.css';
import { VideoCallRedirector } from './containers/consultation/VideoCallRedirector';
import CovidPackages from './containers/lab-test/CovidPackages';
import CovidHomeNavigator from './containers/covid-home/CovidHomeNavigator';
import config from './config';
import WaterLog from './containers/water-log/WaterLog';
import PhysioProgram from './containers/physiotherapy-program/PhysioProgram';
import Redirect from './containers/deep-link/Redirect';
import HealthContentNavigator from './containers/health-content/HealthContentNavigator';
// import PodcastAlbumPage from './containers/health-content/PodcastAlbumPage';
import MaternityCareProgramNavigator from './containers/maternity-care-program/MaternityCareProgramNavigator';
import PristynCareNavigator from './containers/pristyn-care/pristynCareNavigator';
import BackdropCircleIcon from './images/BackdropCircles.svg';
import NewOnboardingHome from './containers/onboarding/NewOnboardingHome';
import NewVisitLogo from './images/common/visitfulllogo.png';
import SideNavigator from './components/home/SideNavigator';
import AccountSection from './components/home/AccountSection';
import EditAccount from './containers/home/EditAccount';
// import ReimbursementStart from './containers/reimbursement/ReimbursementStart';
import MyOrders from './containers/lab-test/AllOrders';
import OnlineConsultationStartPreview from './containers/consultation/OnlineConsultationStartPreview';
import PharmacyOrders from './containers/pharmacy/PharmacyOrders';
import ConsultationStartPreview from './containers/consultation/ConsultationStartPreview';
import RedirectUpdation from './containers/deep-link/RedirectUpdation';
import ReverifyOtp from './containers/onboarding/ReverifyOtp';
import NotFoundPage from './components/home/NotFoundPage';
import RaiseInconvenience from './containers/consultation/RaiseInconvenience';

//Example of code splitting
//Lazy loading will split the code in separate chunks
const LabTestNavigator = lazy(
  () =>
    import(
      './containers/lab-test/LabTestNavigator' /* webpackChunkName: "labs-v2" */
    )
);
// Standalone, auth-free AHC package detail page. Mounted at top level (not under
// LabTestNavigator) so it skips the LOGGED_IN/authToken guard; packageId comes
// from the URL.
const AhcPackageDetail = lazy(
  () =>
    import(
      './containers/lab-test/ahc-package-detail/AhcPackageDetail' /* webpackChunkName: "ahc-package-detail" */
    )
);
const ConsultationNavigator = lazy(
  () =>
    import(
      './containers/consultation/ConsultationNavigator' /* webpackChunkName: "consultation" */
    )
);
const ReimbursementNavigator = lazy(
  () =>
    import(
      './containers/reimbursement/ReimbursementNavigator' /* webpackChunkName: "reimbursement" */
    )
);

const PharmacyNavigator = lazy(
  () => import('./containers/pharmacy/PharmacyNavigator')
);

const HospitalizationNavigator = lazy(
  () => import('./containers/hospitalization/HospitalizationNavigator')
);

const GymNavigator = lazy(
  () => import('./containers/gym-bookings/Navigator.jsx')
);

const OuterContainer = styled.div`
  z-index: 90;
  display: flex;
  flex: 1 0;
  overflow: hidden;
  background: white;
`;

const ModalContainer = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
`;

const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: white;
  width: 335px;
  padding: 1.125rem 1.25rem 1.875rem 1.25rem;
  border-radius: 12px;
  margin: 0 1rem;
  text-align: center;
`;

const CloseContainer = styled(StyledTappable)`
  align-self: flex-end;
`;

const ModalIcon = styled.img`
  width: 5.7rem;
`;

const ModalText = styled(RegularText)`
  font-size: ${() => `${0.875 * process.env.REACT_APP_FONT_MULTIPLIER}rem`};
  line-height: 20px;
  letter-spacing: 0.5px;
  color: #302e6b;
`;

const ModalTitle = styled(BoldText)`
  font-size: ${() => `${0.875 * process.env.REACT_APP_FONT_MULTIPLIER}rem`};
  line-height: 20px;
  color: #131836;
  margin: 0.9375rem 0rem 0.375rem;
`;

// const VideoMax = styled.div`
// min-width: 450px;
// max-width: 450px;
// `;

// const VideoMin = styled.div`
// min-width: 200px;
// max-width: 200px;
// position: fixed;
// right: 3%;
// bottom: 3%;
// height: 30vh;
// z-index: 100000,
// border-radius: 10px;
// `

const videoCallMaximizedCss = {
  display: 'flex',
  flex: '400',
  overflow: 'scroll',
  zIndex: '100000',
};

const videoCallMinimizedCss = {
  minWidth: '200px',
  maxWidth: '200px',
  position: 'fixed',
  right: '3%',
  bottom: '3%',
  height: '30vh',
  overflow: 'scroll',
  zIndex: '100000',
  borderRadius: '10px',
};

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalVisible: true,
      isVideoCallMinimized: false,
    };
    console.log({ props });

    this.amplitudeClient = initializeAmplitudeClient();
    window.__REACT_MOUNTED__ = true;
    // Optional cleanup
    if (window.__reactMountCheckTimer__) {
      clearTimeout(window.__reactMountCheckTimer__);
      delete window.__reactMountCheckTimer__;
    }
  }

  componentDidMount = () => {
    this.initializeCleverTap();
    this.hideModal();
    this.amplitudeClient.init();
    const { authToken, setAppConfig, userId, sponsorName, userInfo } =
      this.props;
    if (userId) {
      // set amplitude userProp
      this.amplitudeClient.initUser(userInfo);
      this.amplitudeConfigured = true;
      // Set GA properties
      this.gtagConfigured = true;
      window.gtag('config', process.env.REACT_APP_GA_ID, {
        user_id: userId,
        app_name: 'VISIT PWA',
        app_version: '1.0.0',
        custom_map: {
          dimension1: 'sponsor_dimension',
        },
        sponsor_dimension: sponsorName,
      });

      LogRocket.identify(userId, {
        name: userInfo.userName,
        email: userInfo.userEmail,
      });
    }
    if (authToken) {
      appConfig(authToken)
        .then((res) => {
          setAppConfig(res.config);
        })
        .catch((err) => {
          console.log(err);
        });
      callMetaApi(authToken).catch((err) => {
        console.log(err);
      });
    }
    // if (this.props.userInfo) {
    //   this.initializeFreshDesk();
    // }
  };

  componentDidUpdate() {
    const { userId, sponsorName, userInfo } = this.props;
    if (!this.gtagConfigured && userId) {
      this.gtagConfigured = true;
      window.gtag('config', process.env.REACT_APP_GA_ID, {
        user_id: userId,
        app_name: 'VISIT PWA',
        app_version: '1.0.0',
        custom_map: {
          dimension1: 'sponsor_dimension',
        },
        sponsor_dimension: sponsorName,
      });
    }
    if (!this.amplitudeConfigured && userId) {
      this.amplitudeConfigured = true;
      // set amplitude userProp
      this.amplitudeClient.initUser(userInfo);
    }
  }

  initializeCleverTap = () => {
    console.log(config.clevertapId); // OK
    if (window.clevertap) {
      window.clevertap.account.push({ id: config.clevertapId });
    }
  };

  // initializeFreshDesk = () => {
  //   console.log(true);
  //   const initFreshChat = () => {
  //     window.fcWidget.init({
  //       config: {
  //         cssNames: {
  //           widget: 'fc_frame_custom_widget',
  //         },
  //       },
  //       token: 'a3138f46-af50-4eca-a681-90c747950123',
  //       host: 'https://wchat.freshchat.com',
  //     });
  //     window.fcWidget.user.setProperties({
  //       name: this.props.userInfo.userName,
  //       phoneNo: this.props.userInfo.userPhone,
  //       sponsorId: this.props.userInfo.sponsorId,
  //       sponsorName: this.props.userInfo.sponsorName,
  //     });
  //   };
  //   function initialize(i, t) {
  //     var e;

  //     return i.getElementById(t)
  //       ? initFreshChat()
  //       : (((e = i.createElement('script')).id = t),
  //         (e.async = !0),
  //         (e.src = 'https://wchat.freshchat.com/js/widget.js'),
  //         (e.onload = initFreshChat),
  //         i.head.appendChild(e));
  //   }
  //   function initiateCall() {
  //     return initialize(document, 'freshchat-js-sdk');
  //   }

  //   window.addEventListener
  //     ? window.addEventListener('load', initiateCall, !1)
  //     : window.attachEvent('load', initiateCall, !1);
  // };
  handleVideoCallMinimize = () => {
    this.setState({
      isVideoCallMinimized: !this.state.isVideoCallMinimized,
    });
  };

  hideModal = () => {
    this.props.hideError();
  };

  render() {
    const { startCall, videoCallPayload } = this.props.video;
    return (
      <OuterContainer id="sub-root">
        <div
          style={{
            minWidth: '450px',
            position: 'absolute',
            left: '5%',
          }}
          id="brand-logo"
        >
          <img
            src={NewVisitLogo}
            style={{
              width: '180px',
              marginRight: '140px',
            }}
            alt="visit logo"
          />
        </div>
        <Router history={history}>
          <Suspense fallback={<LoadingComponent />}>
            <>
              {this.props.authToken && this.props.showNavigator && (
                <div
                  id="brand-logo"
                  style={{
                    minWidth: '450px',
                    position: 'absolute',
                    left: '5%',
                    top: '206px',
                    height: '100vh',
                    overflow: 'scroll',
                  }}
                >
                  <div id={'sideNavigator'}>
                    <SideNavigator />
                  </div>
                </div>
              )}
              {startCall && videoCallPayload ? (
                <Draggable
                  position={!this.state.isVideoCallMinimized && { x: 0, y: 0 }}
                  disabled={!this.state.isVideoCallMinimized}
                >
                  <div
                    style={
                      this.state.isVideoCallMinimized
                        ? videoCallMinimizedCss
                        : videoCallMaximizedCss
                    }
                  >
                    <VideoCallContainer
                      videoCallPayload={videoCallPayload}
                      handleVideoCallMinimize={this.handleVideoCallMinimize}
                    />
                  </div>
                </Draggable>
              ) : (
                ''
              )}
              <Switch>
                <Route path="/" exact component={NewOnboardingHome} />
                <Route
                  path="/ahc-package-detail/:packageId"
                  component={AhcPackageDetail}
                />
                <Route path="/carousel" component={Carousel} />
                <Route path="/login" component={OnboardingStart} />
                <Route path="/verify-otp" component={OnboardingVerifyOtp} />
                <Route path="/re-verify-otp" component={ReverifyOtp} />
                <Route path="/one-last-step" component={OneLastStep} />
                <Route
                  path="/opd-activated"
                  component={SubscriptionActivated}
                />
                <Route path="/select-user" component={SelectUserType} />
                <Route
                  path="/corporate-onboard"
                  component={OnboardingCorporate}
                />
                <Route path="/additional-info" component={WhatsNotCovered} />
                <Route
                  path="/corporate-activated"
                  component={CorporateBenefitsActivated}
                />
                <Route path="/refer" component={ReferContainer} />
                <Route path="/home" component={HomeTabContainer} />
                <Route path="/bot" component={BotChatContainer} />
                <Route path="/consultation" component={ConsultationNavigator} />
                <Route path="/lab-test" component={LabTestNavigator} />
                <Route
                  path="/reimbursement"
                  component={ReimbursementNavigator}
                />
                <Route path="/rewards" component={RewardsNavigator} />
                <Route
                  path="/hospitalization"
                  component={HospitalizationNavigator}
                />
                <Route path="/gym" component={GymNavigator} />
                <Route path="/sso" component={SsoContainer} />
                <Route path="/auth-login" component={AuthTokenContainer} />
                <Route path="/logmeal" component={MealLogNavigator} />
                <Route path="/hra" component={HraNavigator} />
                <Route path="/video" component={VideoCallScreen} />
                <Route
                  path="/processing-payment"
                  component={PhonepePaymentProcessing}
                />
                <Route path="/claims" component={ClaimsNavigator} />
                <Route path="/pharmacy" component={PharmacyNavigator} />
                <Route path="/support" component={SupportWindow} />
                <Route
                  path="/activate-account"
                  component={AccountActivationForm}
                />
                <Route
                  path="/buying-journey"
                  component={BuyingJourneyNavigator}
                />
                <Route path="/manage-dependents" component={ManageDependents} />
                <Route path="/video-call" component={VideoCallContainer} />
                <Route path="/c" component={VideoCallRedirector} />
                <Route path="/covid-packages" component={CovidPackages} />
                <Route path="/covid-home" component={CovidHomeNavigator} />
                <Route path="/covid-swiggy" component={CovidHomeNavigator} />
                <Route path="/covid-gartner" component={CovidHomeNavigator} />
                <Route path="/water-details" component={WaterLog} />
                <Route path="/physio-program" component={PhysioProgram} />
                <Route
                  path="/maternity-care"
                  component={MaternityCareProgramNavigator}
                />
                <Route path="/redirect" component={Redirect} />
                <Route path="/update-details" component={RedirectUpdation} />
                <Route
                  path="/health-content"
                  component={HealthContentNavigator}
                />
                <Route path="/edit-account" component={EditAccount} />
                <Route path="/labs/orders" component={MyOrders} />
                <Route
                  path="/online/orders"
                  component={OnlineConsultationStartPreview}
                />
                <Route
                  path="/medicine/orders"
                  exact
                  component={PharmacyOrders}
                />
                <Route
                  path="/offline/orders"
                  component={ConsultationStartPreview}
                />
                <Route
                  path="/offline/raise-inconvenience/:requestId"
                  component={RaiseInconvenience}
                />
                <Route path="/pristyn-care" component={PristynCareNavigator} />
                <Route path="*" component={NotFoundPage} />
              </Switch>
            </>
          </Suspense>
          {this.props.authToken &&
            this.props.showNavigator &&
            !this.props.dontShowNavigator && (
              <div
                id="account-section"
                style={{
                  minWidth: '450px',
                  position: 'absolute',
                  right: '92px',
                  height: '100vh',
                  overflow: 'scroll',
                }}
              >
                <div>
                  <AccountSection
                    openEditAccount={() => history.push('/edit-account')}
                    style={{ overflow: 'scroll' }}
                  />
                </div>
              </div>
            )}
        </Router>
        {this.props.appError.hasError && (
          <ErrorModal>
            <ModalContainer>
              <ModalBody>
                <CloseContainer onTap={this.hideModal}>
                  <img
                    src={closeIcon}
                    alt="close"
                    width="32"
                    height="32"
                    className="cursor-pointer"
                  />
                </CloseContainer>
                <div
                  style={{
                    backgroundImage: `url(${errorModalBg})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: '114px 114px',
                    backgroundPosition: 'center center',
                    textAlign: 'center',
                  }}
                >
                  <ModalIcon
                    src={errorModalIcon}
                    style={{ width: '164px', height: '116px' }}
                  />
                </div>
                <ModalTitle>{this.props.appError.errorTitle}</ModalTitle>
                <ModalText>{this.props.appError.errorDesc}</ModalText>
              </ModalBody>
            </ModalContainer>
          </ErrorModal>
        )}
        <div id={'backdrop-icon'}>
          <img
            src={BackdropCircleIcon}
            style={{
              width: '200%',
              height: '100%',
              position: 'absolute',
              bottom: '-55%',
              right: '-15%',
              zIndex: '-1',
              userSelect: 'none',
            }}
            alt="backdrop"
          />
        </div>
        {this.props?.isOpen && <FileViewerModal />}
        {this.props?.iframeOpen && <IFrame />}
      </OuterContainer>
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.user.authToken,
  userId: state.user.userId,
  sponsorId: state.user.sponsorId,
  sponsorName: state.user.sponsorName,
  appError: state.app.appError,
  userInfo: state.user,
  sponsorLogo: state.app.config.sponsorLogo,
  showNavigator: state.app.showNavigator,
  dontShowNavigator: state.app.dontShowNavigator,
  video: state.video,
  isOpen: state.app?.appFileViewer?.isOpen,
  iframeOpen: state.app?.iFrame?.isOpen,
});

const mapDispatchToProps = (dispatch) => ({
  hideError: () => {
    dispatch(hideError());
  },
  setAppConfig: (config) => {
    dispatch(setAppConfig(config));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
